<template>
  <div>
    <list-search-box v-model="form" @submit="doSearches" />
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="date" label="操作" width="130" align="left" fixed="left">
          <template v-slot="{row}">
            <span v-if="contractStatus[row.contractStatus]!='草稿'">
              <el-button type="text" @click="createNewContract(row)">生成新合同</el-button>
            </span>
            <span v-else>
              ------
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="left" min-width="160" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" class="el-btn-text-left" @click="$router.push({name:'orderPersionContractInfo',params:{contractNum:row.contractNum},query: { id: row.id, isdisabled: true,transact: '3' }})">
              {{ row.projectName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="contractNum" label="合同编号" align="left" min-width="140" />
        <el-table-column prop="distributorName" label="代理商名称" align="left" min-width="120" />
        <el-table-column prop="departmentName" label="部门" align="left" min-width="120" />
        <el-table-column prop="regionName" label="区域" align="left" width="90" />
        <el-table-column label="现销/赊销" align="left" width="130">
          <template v-slot="{row}">
            <span v-if="row.salesType === 1">现销</span>
            <span v-else-if="row.salesType === 2">赊销</span>
            <span v-else-if="row.salesType === 3">LC</span>
          </template>
        </el-table-column>
        <el-table-column label="分配比例" align="left" width="130">
          <template v-slot="{row}">
            <span>
              {{ row.assignRatio }}%
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="salesManName" label="外销" align="left" width="90" />
        <el-table-column prop="salesManName" label="当前状态" align="left" width="90">
          <template v-slot="{row}">
            {{ contractStatus[row.contractStatus] }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="合同时间" align="left" width="150" />
        <el-table-column prop="date" label="合同附件" width="100" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="showFile(row)">
              操作
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <contract-file-dialog ref="fileDialog" />
  </div>
</template>
<script type="es6">
import listSearchBox from './listSearchBox';
import contractFileDialog from '../contract/contractFileDialog';
import { getOrdersContractList, createNewContract } from '@/API';
import { numDiv, MathMulti } from '../../../libs/util';
import { buildCreateContractComplianceRequest, checkExportCompliance, isDomesticContract } from '@/libs/exportCompliance';
export default {
  data () {
    return {
      contractStatus: ['新建', '代理商发布', '已发布', '已驳回', '代理商取消发布', '草稿'],
      form: {
        projectName: '',
        contractNum: '',
        distributorName: '',
        salesManName: '',
        departmentName: '',
        regionName: '',
        tabType: 2,
        salesType: '0',
        createBeginTime: '',
        createEndTime: '',
        startDistributionRatio: 0,
        endDistributionRatio: 100
      },
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },
  components: {
    listSearchBox,
    contractFileDialog
  },
  computed: {},
  methods: {
    doSearch (resolve) {
      this.tableLoading = true;
      getOrdersContractList({
        ...this.form,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        if (resolve) resolve();
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        if (resolve) resolve();
        this.tableLoading = false;
      });
    },
    doSearches (data, cab) {
      this.page.currentPage = 1;
      this.doSearch();
      cab(false);
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    showFile (row) {
      this.$refs.fileDialog.showFile(row.id);
    },
    // createNewContract (row) {
    //   this.tableLoading = true;
    //   createNewContract(row.id).then((res) => {
    //     this.tableLoading = false;
    //     let json = res.data;
    //     if (json.status === '200') {
    //       this.doSearch();
    //       this.$notify.success('生成新合同成功');
    //     }
    //   }).catch(() => {
    //     this.tableLoading = false;
    //   });
    // },
    async createNewContract (row) {
      this.tableLoading = true;
      if (isDomesticContract(row)) {
        let request;
        try {
          request = await buildCreateContractComplianceRequest(row);
        } catch (error) {
          this.$message.error(error.message);
          this.tableLoading = false;
          return;
        }
        const decision = await checkExportCompliance(this, request);
        if (!decision.allowBusiness) {
          this.tableLoading = false;
          return;
        }
      }
      createNewContract(row.id).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          if (row.isOrderAdminCreate) { // 是否是订单员创建的
            if (row.contractType !== '国际业务下单' && row.contractType !== '国际分销下单') {
              this.$router.push({
                name: 'orderPersionContractHandledraftsDomestic',
                params: {
                  contractNum: json.data
                }
              });
            } else {
              this.$router.push({
                name: 'orderPersionContractHandledraftsInternational',
                params: {
                  contractNum: json.data
                }
              });
            }
          } else {
            if (row.contractType === '国际业务下单' || row.contractType === '国际分销下单') {
              this.$router.push({
                'name': 'orderPersionContractHandlerInternational',
                params: {
                  contractNum: json.data
                },
                query: { isShowInternationalService: row.civilInternational ? row.civilInternational : '0' }
              });
            } else if (row.contractType === '服务订单') {
              this.$router.push({
                'name': 'orderPersionContractHandlerService',
                params: {
                  contractNum: json.data
                }
              });
            } else {
              this.$router.push({
                'name': 'orderPersionContractHandlerDomestic',
                params: {
                  contractNum: json.data
                }
              });
            }
          }
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    proportion (row) {
      let num = 0;
      if (row.contractSum === 0) {
        num = 0;
      } else {
        num = MathMulti(numDiv(row.assignAll, row.contractSum), 100);
      }
      return Number(num) !== 0 ? Number(num).toFixed(2) : 0;
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>
